/**
 * Forbidden page - access denied
 */
import { BaseElement } from '../base-element';
import { navigate } from '../../router';

export class ForbiddenPage extends BaseElement {
  connectedCallback(): void {
    this.updateRender();
  }

  private updateRender(): void {
    this.render(`
      <div class="flex min-h-[400px] flex-col items-center justify-center px-4 py-12 text-center" data-testid="forbidden-page">
        <div class="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-secondary-50 text-secondary-500 dark:bg-secondary-500/10">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="h-10 w-10">
            <path fill-rule="evenodd" d="M12 1.5a5.25 5.25 0 00-5.25 5.25V9H6a3 3 0 00-3 3v6.75a3 3 0 003 3h12a3 3 0 003-3V12a3 3 0 00-3-3h-.75V6.75A5.25 5.25 0 0012 1.5zm-3.75 8.25V6.75a3.75 3.75 0 117.5 0V9H8.25z" clip-rule="evenodd"/>
          </svg>
        </div>
        <h1 class="mb-2 text-2xl font-bold text-neutral-900 dark:text-white">Access Denied</h1>
        <p class="mb-6 text-sm text-neutral-600 dark:text-neutral-400">You don't have permission to view this page.</p>
        <button class="inline-flex items-center justify-center rounded-xl bg-primary-500 px-5 py-2 text-sm font-semibold text-white transition-colors hover:bg-primary-600" data-testid="go-home-btn">Go to Home</button>
      </div>
    `);

    this.attachEventListeners();
  }

  private attachEventListeners(): void {
    const goHomeBtn = this.$('[data-testid="go-home-btn"]');
    if (goHomeBtn) {
      goHomeBtn.addEventListener('click', () => navigate('/trials'));
    }
  }
}

customElements.define('dt-forbidden-page', ForbiddenPage);
